'use client'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { CardLinkBlock, type CardLinkBlockProps } from './CardLinkBlock'
import { grid } from './CardLinkBlock.css'
import { content } from './CardLinkListBlock.css'

type CardLinkListBlockProps = SbBaseBlockProps<{
  cardLinks: ExpectedBlockType<CardLinkBlockProps>
}>

export const CardLinkListBlock = ({ blok }: CardLinkListBlockProps) => {
  return (
    <GridLayout.Root className={grid}>
      {blok.cardLinks.map((nestedBlock) => (
        <div className={content} key={nestedBlock._uid}>
          <CardLinkBlock blok={nestedBlock} />
        </div>
      ))}
    </GridLayout.Root>
  )
}
